import { derived, writable } from 'svelte/store';
import AuthData from '../api/rest/backoffice-data/auth/AuthData';
import { About } from '../api/rest/directus-cms/about/models/About';
import DgPage from '../api/rest/directus-cms/digitalgrow/models/DgPage';
import DonationContactText from '../api/rest/directus-cms/donations/models/DonationButtonData';
import RdPage from '../api/rest/directus-cms/investigation/models/RdPage';
import { locale, locales } from 'svelte-i18n';
import { fallbackLocale } from '../services/i18n';
export const lang = derived(locale, $locale => $locale !== null && $locale !== void 0 ? $locale : fallbackLocale);
export const menus = writable(new Array());
export const menusTrans = writable(new Array());
export const banners = writable(new Array());
export const projects = writable(new Array());
export const partners = writable(new Array());
export const routes = writable(new Map());
export const switchArray = derived([lang, locales], ([$lang, $locales]) => [
    $lang,
    ...$locales.filter(locale => locale !== $lang)
]);
export const isMenuOpen = writable(false);
export const donation = writable(new DonationContactText());
export const aboutPageData = writable(new About());
export const investigationPageData = writable(new RdPage());
export const digitalGrowPageData = writable(new DgPage());
export const authData = writable(new AuthData());
export const keycloakError = writable(false);
export const documentInnerNewsItems = writable(new Array());
export const newsPagination = writable();
export const cookiesPolicyData = writable();
export const privacyPolicyData = writable();
export const newsletterData = writable();
export const newsLabels = writable();
export const commonWebsiteData = writable();
